import apiService from '../api'

export interface AISummaryResponse {
  summary: string
}

export async function getShipmentSummary(shipmentId: string): Promise<string> {
  const res = await apiService.post<{ success?: boolean; data?: AISummaryResponse }>(
    `/ai/shipment/${encodeURIComponent(shipmentId)}/summary`,
    {},
    { timeout: 22000 }
  )
  const data = ((res as { data?: AISummaryResponse })?.data ?? res) as AISummaryResponse
  return typeof data?.summary === 'string' ? data.summary : ''
}

export async function getClearingSummary(clearingId: string): Promise<string> {
  const res = await apiService.post<{ success?: boolean; data?: AISummaryResponse }>(
    `/ai/clearing/${encodeURIComponent(clearingId)}/summary`,
    {},
    { timeout: 22000 }
  )
  const data = ((res as { data?: AISummaryResponse })?.data ?? res) as AISummaryResponse
  return typeof data?.summary === 'string' ? data.summary : ''
}

export async function getContractSummary(contractId: string): Promise<string> {
  const res = await apiService.post<{ success?: boolean; data?: AISummaryResponse }>(
    `/ai/contract/${encodeURIComponent(contractId)}/summary`,
    {},
    { timeout: 22000 }
  )
  const data = ((res as { data?: AISummaryResponse })?.data ?? res) as AISummaryResponse
  return typeof data?.summary === 'string' ? data.summary : ''
}
